/* eslint-disable
    new-cap,
    no-return-assign,
    no-shadow,
    no-unused-vars,
    no-var,
    one-var,
    radix,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import * as d3 from 'd3';
import $ from 'jquery';
import React from 'react';
import _ from 'underscore';

import {debounce} from 'ts-debounce';

import * as Helpers from './Helpers';

const {adminGet} = Helpers;

import UseRow from './UseRowTemplate';

class AdminAggregateView extends Backbone.View {
  static initClass() {
    this.prototype.el = '#aggregate-activity';

    this.prototype.events = {
      'click .js-prev-month': function () {
        return this.makeRequest(-1);
      },
      'click .js-next-month': function () {
        return this.makeRequest(1);
      },
      'click #toggle-aggregate': function () {
        // We don't fetch the aggregate activity because it frequently errors. To see if anyone is using it,
        // we hide it by default behind a toggle and only fetch the activity when the toggle is opened.
        // To unhide, remove class hidden and change arrow to point down. To hide, add class hidden and
        // change the arrow to point right.
        this.$('#toggle-aggregate').toggleClass('glyphicon-chevron-right');
        this.$('#toggle-aggregate').toggleClass('glyphicon-chevron-down');
        this.$('#aggregate-block').toggleClass('hidden');
        return this.makeRequest();
      },
    };
  }

  initialize() {
    const current = new Date();
    this.year = current.getFullYear();
    this.month = current.getMonth();
    this.months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    this.fetchForMonth = debounce(this.fetchForMonth, 1000);
    return (this.colorScale = d3.interpolateRgb('#fff', '#69dd9a'));
  }

  makeRequest(monthIncr) {
    if (monthIncr == null) {
      monthIncr = 0;
    }
    this.$('.centering-spinner-wrapper').removeClass('hidden');
    this.$('.spinner').removeClass('hidden');
    this.$('tbody').empty();
    this.$('.use-rows-title span').text('Click a cell on the calendar to show per-member stats.');
    this.month += monthIncr;
    if (this.month < 0) {
      this.year -= 1;
      this.month = 11;
    } else if (this.month === 12) {
      this.year += 1;
      this.month = 0;
    }
    this.$('.month').text(`${this.months[this.month]} ${this.year}`);
    return this.fetchForMonth();
  }

  formatDate(dateStr) {
    const [y, m, d] = Array.from(dateStr.split('-'));
    return `${m}/${d}/${y}`;
  }

  cellClickFn(result, dateStr) {
    return ((result, dateStr, ref) =>
      function (e) {
        ref.$('.use-rows tbody').empty();
        const sorted = _.sortBy(result.users, (user) => user.write + user.read);
        for (const user of Array.from(sorted)) {
          ref.$('.use-rows tbody').append(UseRow(user));
        }
        const u = result.users.length === 1 ? 'member' : 'members';
        return ref.$('.use-rows-title span').text(`${dateStr}: ${result.users.length} active ${u}`);
      })(result, dateStr, this);
  }

  fetchForMonth() {
    return adminGet('/1/api/admin/aggregate/month', {year: this.year, month: this.month + 1}).done((res) => {
      this.$('.centering-spinner-wrapper').addClass('hidden');
      this.$('.spinner').addClass('hidden');
      let before = true;
      let after = false;
      return (() => {
        const result1 = [];
        for (let week = 0; week < res.days.length / 7; week++) {
          var $col, result;
          const $row = $('<tr>');
          this.$('.calendar tbody').append($row);
          for (let day = 0; day < 7; day++) {
            $col = $('<td>');
            result = res.days[week * 7 + day];
            const dateNum = parseInt(result.date.split('-')[2]);
            if (!before && dateNum === 1) {
              after = true;
            }
            if (dateNum === 1) {
              before = false;
            }
            $col.text(dateNum);
            if (before || after) {
              $col.css('color', '#aaa');
            }
            $row.append($col);
            $col.click(this.cellClickFn(result, this.formatDate(result.date)));
            const color = this.colorScale(Math.min(result.users.length / res.max_users, 1));
            $col.css('background-color', color);
          }

          result = res.weeks[week];
          $col = $('<td>');
          $col.text(result.users.length).css('font-weight', 600);
          $col.click(this.cellClickFn(result, `Week of ${this.formatDate(result.date)}`));
          result1.push($row.append($col));
        }
        return result1;
      })();
    });
  }
}
AdminAggregateView.initClass();

export default AdminAggregateView;
